import { useField, useFormikContext } from "formik";
import "./style.scss";
import { useState } from "react";
import Error from "../../atoms/Error";
import Info from "../Info";

const TextInput = ({
  label,
  icon,
  InputHeight = "small",
  info,
  customBlur,
  blurError,
  width,
  isDisabled,
  required,
  className,
  ...props
}) => {
  const [field, meta] = useField(props);
  const { setFieldTouched } = useFormikContext();
  const [placeholder, setPlaceholder] = useState(props.customholder);

   const handleBlur = (event) => {
    field.onBlur(event);
    if (props.onBlur) {
      props.onBlur(event);
    }
  };

  return (
    <>
      {label && <label htmlFor={props.id || props.name}>{label}</label>}
      <div
        className={`d-flex align-items-center input-container input_icon_wrap`}
        style={{ width: width }}
      >
        {icon && <div className={`input_icon`}>{icon}</div>}
        <input
          {...field}
          {...props}
          className={`
            ${
              (meta.touched && meta.error) || blurError ? "error-input " : ""
            }
            ${
            InputHeight === "small" ? "primary-input-small" : "auth_input"
          } ${className}`}
          placeholder={props.placeholder}
          onBlur={(e) => {
            handleBlur(e);
            setFieldTouched(props.name, true);
          }}
          disabled={isDisabled}
        />
      </div>

      {(meta.touched && meta.error) || blurError ? (
        // <div
        //   className="error-input-message"
        //   style={{ marginTop: InputHeight === 'small' ? '4px' : '8px' }}
        // >
        //   {meta.error}
        // </div>
        <Error error={meta.error || blurError} type={InputHeight} />
      ) : null}
      {info || !(meta.touched && meta.error && blurError) ? (
        <Info info={info} />
      ) : null}
    </>
  );
};

export default TextInput;
